import LearnPageLayout from "@/components/LearnPageLayout";
import { pageBcbsSaint } from "./learnDataBcbsSaint";

const BcbsSaintPage = () => (
  <LearnPageLayout
    title={pageBcbsSaint.title}
    description={pageBcbsSaint.description}
    canonical={pageBcbsSaint.canonical}
    h1={pageBcbsSaint.h1}
    breadcrumbLabel={pageBcbsSaint.breadcrumbLabel}
    crumbs={pageBcbsSaint.crumbs}
    shortAnswer={pageBcbsSaint.shortAnswer}
    keyTakeaways={pageBcbsSaint.keyTakeaways}
    sections={pageBcbsSaint.sections}
    faqs={pageBcbsSaint.faqs}
    sources={pageBcbsSaint.sources}
    schemaJson={pageBcbsSaint.schemaJson}
    relatedLinks={pageBcbsSaint.relatedLinks}
    reviewBlock={pageBcbsSaint.reviewBlock}
  />
);

export default BcbsSaintPage;
